import { captureException } from '@sentry/react';

import { resolvedAvailableSitesProvider } from '@townsquare/available-sites-provider/provider';
import { resolvedCollabGraphProvider } from '@townsquare/collab-graph-provider';
import type { CollaborationGraphContainer } from '@townsquare/collab-graph-provider/types';

export const fetchWhereYouWorkContainers = async ({
	cloudIdsToFilterFor,
	orgId,
	accountId,
}: {
	cloudIdsToFilterFor?: string[];
	orgId: string;
	accountId: string;
}): Promise<CollaborationGraphContainer[]> => {
	const { data: apsData, error: apsError } = cloudIdsToFilterFor
		? { data: cloudIdsToFilterFor, error: null }
		: await resolvedAvailableSitesProvider.getAvailableSitesCloudIds({
				cloudIdsToFilterFor,
				orgId,
			});

	if (!apsData.length) {
		if (apsError) {
			const error = new Error(
				'fetchWhereYouWorkContainers: failed to load available sites cloud ids',
			);
			captureException(error, {
				tags: { source: 'fetchWhereYouWorkContainers', provider: 'availableSitesProvider' },
			});

			throw error;
		}

		return [];
	}
	const { data, error } = await resolvedCollabGraphProvider.getCollabGraphContainers(
		accountId,
		apsData,
	);
	if (error) {
		const containerError = new Error(
			'fetchWhereYouWorkContainers: failed to load collab graph containers',
		);
		captureException(containerError, {
			tags: { source: 'fetchWhereYouWorkContainers', provider: 'collabGraphProvider' },
		});

		throw containerError;
	}
	return data;
};
